import { FilterIcon, GridIcon, ListIcon, SortIcon } from '@sketchnote/icons';
import cn from 'classnames';
import * as React from 'react';

import { MoreActionMenu, MoreActionMenuProps } from '../more-menu';
import { Tabs, TabsProps } from '../tab-bar';

export interface FilterType {
  label: string;
  value: string;
}
export interface SortType {
  label: string;
  value: string;
}

interface TabSortFilterProps {
  children: JSX.Element[];
  onChange?: TabsProps['onChange'];
  filterOption?: FilterType[];
  sortOption?: SortType[];
  onFilterChange?: (arg: FilterType) => void;
  onSortChange?: (arg: SortType) => void;
  values: { sortValue: SortType; filterValue: FilterType };
  selected: number;
  workspaceId?: string;
}

export const TabSortFilter = ({
  children,
  onChange,
  filterOption,
  sortOption,
  onFilterChange,
  onSortChange,
  values,
  selected,
  workspaceId,
}: TabSortFilterProps): JSX.Element => {
  return (
    <Tabs
      selected={selected}
      size="small"
      onChange={onChange}
      workspaceId={workspaceId}
      extra={
        <div className="text-gray-500 flex">
          <MoreActionMenu
            menuItems={filterOption as MoreActionMenuProps['menuItems']}
            icon={<FilterLabel label={values.filterValue.label} isFilterOpened={true} />}
            onClickMenuItem={onFilterChange as MoreActionMenuProps['onClickMenuItem']}
          />
          <span className="mr-24" />
          <MoreActionMenu
            menuItems={sortOption as MoreActionMenuProps['menuItems']}
            icon={
              <SortActiveText
                isSortMenuOpened={false}
                sortTxt={'Sort'}
                activeSortValue={values.sortValue}
              />
            }
            onClickMenuItem={onSortChange as MoreActionMenuProps['onClickMenuItem']}
          />
        </div>
      }
      className="justify-between border-b"
    >
      {children}
    </Tabs>
  );
};

export interface FilterLabelProps {
  label: string;
  isFilterOpened: boolean;
}

export const FilterLabel = ({ label, isFilterOpened }: FilterLabelProps) => (
  <div
    className={cn({
      'flex items-center font-medium text-sm': true,
      'text-gray-999': isFilterOpened,
    })}
  >
    <FilterIcon className="mr-5" />
    <span>{`${label}`}</span>
  </div>
);

export const SortActiveText = ({
  sortTxt,
  activeSortValue,
  isSortMenuOpened,
  icon = <SortIcon className="mr-5" />,
}: SortActiveTextProps): JSX.Element => (
  <span
    className={cn({
      'flex items-center font-medium text-sm text-gray-500': true,
      'text-gray-999': isSortMenuOpened,
    })}
  >
    {icon}
    <span>{`${sortTxt}: ${activeSortValue.label}`}</span>
  </span>
);

export interface SortActiveTextProps {
  sortTxt: string;
  activeSortValue: {
    label: string;
    value: string;
  };
  isSortMenuOpened: boolean;
  icon?: JSX.Element;
}

export const ViewFile = ({
  viewText,
  activeViewValue,
  isViewMenuOpened,
}: ViewProps): JSX.Element => (
  <span
    className={cn({
      'flex items-center font-medium text-sm': true,
      'text-gray-999': isViewMenuOpened,
    })}
  >
    <span className="mr-3 block mt-3">
      {activeViewValue.value === 'list' ? <ListIcon className="mt-2" /> : <GridIcon />}
    </span>
    <span>{` ${viewText}: ${activeViewValue.label}`}</span>
  </span>
);
export interface ViewProps {
  viewText: string;
  activeViewValue: {
    label: string;
    value: string;
  };
  isViewMenuOpened?: boolean;
}
